import React from 'react';
import { AlertTriangle, Info, ShieldAlert } from 'lucide-react';
export function HelpCloseOnesSection() {
  return <section id="dopomoga-blyzkij-lyudyni" className="py-20 md:py-28 bg-[#F5F0E8]" data-id="element-514">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-515">
        <div className="text-center mb-12" data-id="element-516">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-517">
            Що робити, якщо хтось близький грає неконтрольовано
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-518" />
        </div>

        <div className="mb-16" data-id="element-519">
          <p className="text-lg text-gray-700 leading-relaxed bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-520">
            Коли близька людина стикається з проблемною ігровою поведінкою, це
            може викликати тривогу, злість, розгубленість або безсилля. Важливо
            усвідомити свої емоції і реакції, та спробувати опанувати себе і
            повірити, що Ваша підтримка і увага може дійсно допомогти, якщо Ви
            будете самі усвідомлені і спокійні. Також важливо діяти обережно.
            Спробуйте для початку просто спокійно розпочати розмову, щоб людина,
            яка, можливо ще не визнає реального стану речей, відчула, що Ви
            готові їй допомогти без засудження чи звинувачень. Ваша щира
            зацікавленість і увага до близької Вам людини, її емоційного стану і
            переживань в її житті, Ваша підтримка і любов можуть стати точкою
            опори, в якій близька Вам людина може прийняти рішення визнати
            проблему і обрати діяти з Вашою підтримкою. При цьому не нехтуйте
            увагою до себе і до власного емоційного стану. Піклуйтеся про себе і
            про свій ресурс.
          </p>
        </div>

        <div className="mb-20" data-id="element-521">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#0A5E5C] mb-10 text-center" data-id="element-522">
            Деякі поради, які можливо Вам допоможуть
          </h3>

          <div className="space-y-6" data-id="element-523">
            {[{
            title: 'Спробуйте зрозуміти проблему',
            text: "Ігрова залежність — це складна поведінкова проблема, яка може бути пов'язана зі стресом, емоційними труднощами або бажанням уникнути проблем. Спробуйте зрозуміти близьку Вам людину, яка грає неконтрольовано, що вона уникає, який стрес міг стати причиною занурення в неконтрольовану гру. Якщо людина Вам дійсно близька і її життя Вам знайоме, Ви зможете зрозуміти обставини її життя, які могли спричинити втрату нею контролю над грою в азартні ігри"
          }, {
            title: 'Говоріть спокійно та без звинувачень',
            text: 'Розмовляйте з близькою Вам людиною. Спробуйте будувати розмови таким чином, щоб викликати атмосферу довіри і прийняття ситуації, що склалася. В жодному разі не засуджуйте, не звинувачуйте, не жалійте. Спробуйте обережно запросити людину разом спокійно дослідити той стан, в якому перебуває людина, проявіть щирий інтерес до того, що вона відчуває, коли грає і що заважає їй зупинитись, чого вона уникає, занурюючись в гру, чого їй не вистачає у реальному житті, для чого вона повертається у гру і не може зупинитись. Досліджуйте це разом і не засуджуйте нічого з того, що Ви виявите. Такий діалог, спокійне обговорення і обмін думками може запустити процес усвідомлення в людині її проблемної ігрової поведінки і стати початком реальних позитивних змін.'
          }, {
            title: 'Не намагайтеся контролювати все',
            text: 'Надмірний контроль може призвести до конфліктів або приховування проблеми.'
          }, {
            title: 'Не покривайте борги',
            text: 'Погашення боргів або постійна фінансова допомога може лише відкласти вирішення проблеми.'
          }, {
            title: 'Заохочуйте звернення по допомогу',
            text: 'Можна запропонувати звернутися до психолога, консультанта або груп підтримки. Головне не тиснути і спробувати дочекатись, коли людина прийде до такого рішення самостійно і усвідомлено.'
          }, {
            title: 'Підтримуйте позитивні зміни',
            text: 'Навіть невеликі кроки — наприклад, зменшення часу гри — можуть бути важливими. Складіть разом певний план маленьких кроків і спробуйте надати підтримку в його слідуванні, даючи підтримку і свою увагу.'
          }, {
            title: 'Допоможіть знайти альтернативні заняття',
            text: 'Спорт, хобі, подорожі або навчання можуть допомогти замінити час та увагу, які раніше займала гра. Спробуйте заохотити людину до нового досвіду від нових активностей, спілкування, подорожей тощо, які можуть її захопити і дати позитивні емоції і позитивний досвід.'
          }, {
            title: 'Встановіть власні межі',
            text: 'Важливо визначити, що для Вас є неприйнятним. Не давати гроші для гри і не брати фінансову відповідальність за чужі борги. Це стосується і Вашого емоційного стану.'
          }, {
            title: 'Піклуйтеся про себе',
            text: 'Життя поруч з людиною із залежністю може бути емоційно складним, тому важливо не забувати про власне благополуччя. Допомога і підтримка близькій людині не повинна спустошувати Вас. Ви не зможете повноцінно допомогти комусь, якщо самі втратили емоційну рівновагу. Бережіть себе.'
          }, {
            title: "Пам'ятайте, що зміни потребують часу",
            text: 'Подолання проблемної поведінки може зайняти час, але підтримка близьких допомагає рухатися вперед.'
          }].map((tip, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex gap-4 md:gap-6" data-id="element-524">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#0A5E5C]/10 text-[#0A5E5C] font-bold flex items-center justify-center text-lg" data-id="element-525">
                  {index + 1}
                </div>
                <div data-id="element-526">
                  <h4 className="text-xl font-bold text-[#0A5E5C] mb-2" data-id="element-527">
                    {tip.title}
                  </h4>
                  <p className="text-gray-700 leading-relaxed" data-id="element-528">{tip.text}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* LEGAL PROTECTION SECTION */}
        <div className="bg-white rounded-2xl shadow-lg border-2 border-[#0A5E5C] overflow-hidden" data-id="element-529">
          <div className="bg-[#0A5E5C] p-6 text-white flex items-center gap-4" data-id="element-530">
            <ShieldAlert className="w-8 h-8 flex-shrink-0 text-[#D4A843]" data-id="element-531" />
            <h3 className="text-xl md:text-2xl font-serif font-bold" data-id="element-532">
              Якщо є загроза фінансовій безпеці Вашої родини через
              неконтрольовану гру Вашої близької людини (родича)
            </h3>
          </div>

          <div className="p-6 md:p-8" data-id="element-533">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-534">
              Якщо близька Вам людина (родич) не визнає з якихось обставин
              наявності проблем з азартними іграми і не виявляє бажання шукати
              виходу для її подолання, і можливо неконтрольованою грою загрожує
              фінансовій безпеці Вашої родини, Ви можете скористатися деякими
              юридичними інструментами для захисту.
            </p>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-8" data-id="element-535">
              <p className="font-medium text-gray-800 leading-relaxed" data-id="element-536">
                Подати Заяву про обмеження такої особи до Державного агентства
                «ПЛЕЙСІТІ» через сайт{' '}
                <a href="http://www.playcity.gov.ua" className="text-[#0A5E5C] underline hover:text-[#D4A843]" data-id="element-537">
                  www.playcity.gov.ua
                </a>{' '}
                в Розділі «Громадянам» є опція «Заява про обмеження», або у
                письмовій формі. Внаслідок подання такої заяви особа буде
                внесена до Реєстру осіб, яким обмежено доступ до гральних
                закладів та/або участь в азартних іграх (далі – Реєстр).
              </p>
            </div>

            <ul className="space-y-6" data-id="element-538">
              <li className="flex items-start gap-4" data-id="element-539">
                <Info className="w-6 h-6 text-[#D4A843] flex-shrink-0 mt-1" data-id="element-540" />
                <p className="text-gray-700 leading-relaxed" data-id="element-541">
                  Важливо, що Ви можете подати таку заяву лише щодо родича
                  першого рівня споріднення, а це можуть бути батьки, чоловік,
                  дружина, діти (в тому числі усиновлені) або, якщо Ви є
                  законним представником особи, яку необхідно обмежити в доступі
                  до гри в азартні ігри. Разом із заявою, Вам необхідно подати
                  документ, який підтвердить Ваші родинні стосунки з особою, яку
                  необхідно обмежити в доступі до гри в азартні ігри. Ви маєте
                  надати копію такого документа і засвідчити її власним
                  підписом.
                </p>
              </li>

              <li className="flex items-start gap-4" data-id="element-542">
                <AlertTriangle className="w-6 h-6 text-[#D4A843] flex-shrink-0 mt-1" data-id="element-543" />
                <p className="text-gray-700 leading-relaxed" data-id="element-544">
                  Подати заяву можна лише щодо особи, якій виповнилось 21 рік.
                  Особи, що є молодшими за 21 рік, не можуть допускатися до гри
                  в азартні ігри в силу вимог чинного законодавства. Якщо
                  легальний організатор азартних ігор допустив особу молодшу 21
                  року до гри в азартні ігри, за це передбачена сувора
                  відповідальність такого організатора.
                </p>
              </li>

              <li className="flex items-start gap-4" data-id="element-545">
                <Info className="w-6 h-6 text-[#D4A843] flex-shrink-0 mt-1" data-id="element-546" />
                <div data-id="element-547">
                  <p className="text-gray-700 leading-relaxed mb-4" data-id="element-548">
                    Важливо врахувати, що до заяви необхідно додати
                    обґрунтування та документи, що підтверджують необхідність
                    встановлення обмеження доступу до участі в азартних іграх
                    через одну з таких обставин:
                  </p>
                  <ol className="list-decimal pl-5 space-y-3 text-gray-700" data-id="element-549">
                    <li className="pl-2" data-id="element-550">
                      перевищення витрат на гру над особистими доходами особи,
                      що ставить таку особу або його сім'ю у скрутне матеріальне
                      становище;
                    </li>
                    <li className="pl-2" data-id="element-551">
                      перевищення витрат на гру над особистими доходами особи,
                      що ставить гравця або його сім'ю у скрутне матеріальне
                      становище, яке здійснюється з використанням коштів,
                      отриманих у позику, в тому числі на умовах фінансового
                      кредиту;
                    </li>
                    <li className="pl-2" data-id="element-552">
                      наявність боргових зобов'язань на суму більш як 100
                      прожиткових мінімумів доходів громадян;
                    </li>
                    <li className="pl-2" data-id="element-553">
                      ухилення особи від сплати аліментів впродовж більше трьох
                      місяців;
                    </li>
                    <li className="pl-2" data-id="element-554">
                      якщо особа або члени її сім'ї є отримувачами житлової
                      субсидії чи пільг на сплату житлово-комунальних послуг.
                    </li>
                  </ol>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-555">
                <Info className="w-6 h-6 text-[#D4A843] flex-shrink-0 mt-1" data-id="element-556" />
                <p className="text-gray-700 leading-relaxed" data-id="element-557">
                  Важливо, що поданням такої заяви Ви можете обмежити доступ
                  зазначеної особи до гри в азартні ігри на строк до 6 місяців.
                  Для обмеження доступу на більш тривалий строк, необхідно
                  звертатися до суду.
                </p>
              </li>
            </ul>

            <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-558">
              <p className="text-gray-600 italic" data-id="element-559">
                Якщо Вам потрібна більш детальна інформація з цього питання,
                будь ласка звертайтесь до нас через заповнення форми на сайті
                або пишіть на нашу електронну пошту.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}